<template>
  <modal size="small" :title="title" v-model="openModal">
    <Form action="">
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <div>
            <Label bold>Documento</Label>
          </div>
          <Radio
            v-for="model in models"
            v-model="edit.documento"
            :label="model.label"
            :option="model.value"
            :key="model.value"
            :disabled="isEditDocument"
          />
        </b-col>
        <b-col md="6" lg="6" sm="12" v-if="!isGerencial">
          <div>
            <Label bold>Ambiente</Label>
          </div>
          <Radio
            v-for="environment in environments"
            v-model="edit.ambiente"
            :label="environment.name"
            :option="environment.id"
            :key="environment.id"
            :disabled="isEditEnvironment"
            @input="handleEnvironments"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6" lg="6" sm="12" v-if="!isGerencial">
          <Input
            label="Série"
            id="serie"
            type="number"
            v-model="edit.serie"
            labelBold
            :disabled="isEditDocument"
            v-if="!isDocumentSelectSAT"
            :description="errorValue('serie')"
            :error="!!errorValue('serie')"
            :mask="'###'"
          />

          <Input
            label="Código de ativação"
            id="codigoAtivacao"
            v-model="edit.codigoAtivacao"
            labelBold
            v-if="isDocumentSelectSAT"
          />
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <Input
            :mask="'#########'"
            label="Próximo documento"
            type="number"
            id="proximaNota"
            v-model="edit.proximaNota"
            labelBold
            :description="errorValue('proximaNota')"
            :error="!!errorValue('proximaNota')"
          />
        </b-col>
      </b-row>
      <b-row v-if="isDocumentSelectSAT">
        <b-col md="6" lg="6" sm="12">
          <Input
            id="versao"
            label="Versão do SAT"
            v-model="edit.versao"
            labelBold
          />
        </b-col>

        <b-col md="6" lg="6" sm="12">
          <SelectWithSearch
            id="satIdentification"
            label="CNPJ da Empresa Desenvolvedora"
            labelBusca="description"
            placeholder="Selecione um CNPJ"
            ref="searchSatIdentification"
            v-model="edit.satIdentification"
            :options="satIdentificationCollection"
            :change="changeSatIdentificationSelected"
          >
            <template slot="no-options">Nenhum CNPJ encontrado</template>
            <template slot="options" slot-scope="props">
              <div class="selected">
                {{ props.data.description }} - {{ props.data.identification }}
              </div>
            </template>
            <template slot="selected" slot-scope="props">
              <div class="selected" style="text-transform: uppercase">
                {{ props.data.description }} - {{ props.data.identification }}
              </div>
            </template>
          </SelectWithSearch>
        </b-col>
      </b-row>

      <b-row v-if="isDocumentSelectSAT">
        <b-col md="6" lg="6" sm="6">
          <div>
            <Label bold>Instalador</Label>
          </div>
          <Button
            type="primary"
            full-width
            align="center"
            @click="openSATDownloads"
          >
            <icon-download title="Download" /> Baixar instalador SAT
          </Button>
        </b-col>
        <b-col md="6" lg="6" sm="6">
          <div>
            <Label bold>Assinatura</Label>
          </div>
          <Button
            v-if="!edit.assinatura"
            type="primary"
            full-width
            align="center"
            @click="generateSignature"
          >
            Gerar assinatura
          </Button>
          <Input
            id="assinatura"
            v-model="edit.assinatura"
            :maxlength="344"
            labelBold
            v-if="edit.assinatura"
          />
        </b-col>
      </b-row>

      <b-row v-if="isDocumentSelectNFCE">
        <b-col md="6" lg="6" sm="12">
          <Input
            :mask="'######'"
            type="number"
            id="idTokenCSS"
            label="ID. Token (CSC)"
            v-model="edit.idTokenCSC"
            labelBold
          />
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <Input
            id="tokenCSS"
            label="Token (CSC)"
            v-model="edit.tokenCSC"
            labelBold
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6" lg="6" sm="12">
          <b-row>
            <b-col>
              <Label bold htmlFor="ativo">Status</Label>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <checkbox-switch
                v-model="edit.ativo"
                id="ativo"
                style="margin: 0px !important"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" lg="6" sm="12" v-if="isDocumentSelectNFCE">
          <b-row>
            <b-col>
              <Label htmlFor="isReducedPrint" bold>{{ printLabel }}</Label>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <checkbox-switch
                v-model="edit.isReducedPrint"
                id="printType"
                style="margin: 0px !important"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" lg="6" sm="12" v-if="isDocumentSelectNFE">
          <Label bold htmlFor="intermediatorNFe">
            Enviar dados do Intermediador
          </Label>
          <checkbox-switch
            v-model="edit.intermediatorNFe"
            id="intermediatorNFe"
            style="margin: 0px !important"
          />
        </b-col>
        <b-col md="6" lg="6" sm="12" v-if="isDocumentSelectSAT">
          <div>
            <Label></Label>
          </div>
        </b-col>
        <b-col md="6" lg="6" sm="12" v-if="isDocumentSelectNFCE">
          <Label bold htmlFor="intermediatorNFCe"
            >Enviar dados do Intermediador
          </Label>
          <checkbox-switch
            v-model="edit.intermediatorNFCe"
            id="intermediatorNFCe"
            style="margin: 0px !important"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="isClientFromCE && isDocumentSelectNFCE">
          <strong style="color: red; font-size: 14px">
            Emissão Via WebService
          </strong>
        </b-col>
      </b-row>

      <ContainerButtons>
        <Button @click="handleSave" type="success" rounded> Salvar </Button>
      </ContainerButtons>
    </Form>
  </modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import IconDownload from 'vue-material-design-icons/Download';
import Modal from '../../../../components/Modal';
import {
  Form,
  Input,
  Button,
  CheckboxSwitch,
  Label,
  ContainerButtons,
  Radio,
  SelectWithSearch,
} from '../../../../components/Form';
import { AMBIENTE } from '../../enums/Ambientes';
import {
  MODELO,
  MODELO_LABEL,
  PRINT,
  PRINT_LABEL,
} from '../../enums/Documento';
import ModalConfigurationData from './ModalConfigurationData';
import { ClientMixin } from '../../../Application';

export default {
  name: 'ModalConfiguration',
  mixins: [ClientMixin],
  components: {
    IconDownload,
    Button,
    Modal,
    Form,
    Label,
    Input,
    CheckboxSwitch,
    ContainerButtons,
    Radio,
    SelectWithSearch,
  },
  props: {
    avaliableSat: {
      type: Boolean,
    },
    save: {
      type: Function,
      required: true,
    },
    data: {
      type: ModalConfigurationData,
      required: true,
    },
    environments: {
      type: Array,
      required: true,
    },
    value: {
      type: Boolean,
      default: () => false,
      required: true,
    },
  },
  data() {
    return {
      printLabel: PRINT_LABEL[PRINT.REDUCED],
      openModal: this.open,
      edit: {},
      errors: {},
    };
  },
  watch: {
    value(newValue) {
      this.openModal = newValue;
    },
    data(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.edit = newValue;
        this.setSatIdentification();
      }
    },
    openModal(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
  },
  async mounted() {
    await this.getClient();
    await this.setSatIdentificationCollection();
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('sat', ['setSatIdentificationCollection']),
    changeSatIdentificationSelected(selected) {
      if (selected) {
        this.edit.satIdentification = selected;
      }
    },
    setSatIdentification() {
      const zucchettiIdentification = '03916076000400';
      const compufacilIdentification = '23379897000101';

      this.edit.satIdentification = this.satIdentificationCollection.find(
        (e) => e.identification === this.edit.satIdentification,
      );

      if (!this.edit.satIdentification && !this.edit.id) {
        this.edit.satIdentification = this.satIdentificationCollection.find(
          (e) => e.identification === zucchettiIdentification,
        );
      }

      if (!this.edit.satIdentification && this.edit.id) {
        this.edit.satIdentification = this.satIdentificationCollection.find(
          (e) => e.identification === compufacilIdentification,
        );
      }
    },
    handleEnvironments(environment) {
      if (this.isDocumentSelectSAT) {
        this.edit.ambiente = AMBIENTE.PRODUCAO;
        return;
      }

      if (environment === AMBIENTE.HOMOLOGACAO) {
        this.edit.serie = '99';
      }

      if (environment === AMBIENTE.PRODUCAO) {
        this.edit.serie = '';
      }
    },
    async generateSignature() {
      try {
        this.setLoading(true);
        const { data } = await this.$http.post('fiscal.sat-generate-signature');
        this.edit.assinatura = data.signature;
        this.setLoading(false);
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.setLoading(false);
      }
    },
    openSATDownloads() {
      window.open('https://compufour.s3.sa-east-1.amazonaws.com/uploads/clipp-exe/Instalador_ClippFacilIntegrador.exe', '_blank');
      setTimeout(() => {
        window.open('https://suporte.compufour.com.br/artigos/1639', '_blank');
      }, 1000);
    },
    async handleSave() {
      const { schema, validate } = this.$validate;

      let serieSchemaValidation = schema.string().required();
      if (this.isDocumentSelectSAT) {
        serieSchemaValidation = schema.string().nullable();
      }

      const schemaConfiguration = schema.object().shape({
        proximaNota: schema.string().required(),
        serie: serieSchemaValidation,
      });

      this.errors = {};
      this.edit.printType = this.edit.isReducedPrint
        ? PRINT.REDUCED
        : PRINT.NORMAL;

      if (this.edit.satIdentification) {
        this.edit.satIdentification =
          this.edit.satIdentification.identification;
      }

      await validate(schemaConfiguration, this.edit);

      this.save(this.edit);
    },
    errorValue(field) {
      return this.errors[field];
    },
  },
  computed: {
    ...mapState('sat', ['satIdentificationCollection']),
    models() {
      const models = [
        { value: MODELO.NFE, label: MODELO_LABEL[MODELO.NFE] },
        { value: MODELO.NFCE, label: MODELO_LABEL[MODELO.NFCE] },
        { value: MODELO.MDFE, label: MODELO_LABEL[MODELO.MDFE] },
        { value: MODELO.GERENCIAL, label: MODELO_LABEL[MODELO.GERENCIAL] },
      ];

      if (this.avaliableSat) {
        models.push({ value: MODELO.SAT, label: MODELO_LABEL[MODELO.SAT] });
      }

      return models;
    },
    isEditDocument() {
      return !!this.edit.id;
    },
    isGerencial() {
      return this.edit.documento === MODELO.GERENCIAL;
    },
    isEditEnvironment() {
      this.handleEnvironments();

      if (this.isDocumentSelectSAT) {
        return true;
      }

      return !!this.edit.id;
    },
    title() {
      return this.edit.id ? 'Editar configuração' : 'Nova configuração';
    },
    isDocumentSelectSAT() {
      return this.edit.documento === MODELO.SAT;
    },
    isDocumentSelectNFE() {
      return this.edit.documento === MODELO.NFE;
    },
    isDocumentSelectNFCE() {
      return this.edit.documento === MODELO.NFCE;
    },
  },
};
</script>
